/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerPayoutListConfig } from '../../config/header.config';

export interface IHeaderPayoutListListPluginMethods extends IPluginMethodMap {
  getHeaderPayoutListListSync(args?: any): any;
}

export class HeaderPayoutListListPlugin implements IAgentPlugin {
  readonly methods: IHeaderPayoutListListPluginMethods;

  constructor() {
    this.methods = {
      getHeaderPayoutListListSync: this.getHeaderPayoutListListSync.bind(this),
    };
  }

  getHeaderPayoutListListSync(args?: any) {
    return {
      error: headerPayoutListConfig,
    };
  }
}
